import callApi from '&/utils/callApi';

import * as types from '../constants/types';

const API = '/articles';

export const fetchArticles = () => async (dispatch, getState) => {
	const skip = getState().articles.all.length;

	const data = await callApi.get(`${API}?skip=${skip}`);

	if (data.articles.length < 10) {
		return dispatch({
			type: types.articles.END_ARTICLES,
			payload: {
				articles: data.articles,
			},
		});
	}

	dispatch({
		type: types.articles.FETCH_ARTICLES,
		payload: {
			articles: data.articles,
		},
	});
};

export const getArticles = () => async dispatch => {
	const data = await callApi.get(`${API}`);

	dispatch({
		type: types.articles.GET_ARTICLES,
		payload: {
			articles: data.articles,
		},
	});
};

export const addArticle = article => async dispatch => {
	const data = await callApi.post(API, article);

	if (data.article) {
		dispatch({
			type: types.articles.ADD_ARTICLE,
			payload: {
				article: data.article,
			},
		});
	}

	return data;
};

export const editArticle = article => async dispatch => {
	const data = await callApi.put(`${API}/${article._id}`, article);

	if (data.article) {
		dispatch({
			type: types.articles.EDIT_ARTICLE,
			payload: {
				article: data.article,
			},
		});
	}

	return data;
};

export const removeArticle = articleId => async dispatch => {
	await callApi.delete(`${API}/${articleId}`);

	dispatch({
		type: types.articles.REMOVE_ARTICLE,
		payload: {
			articleId,
		},
	});
};

export const addViews = slug => async dispatch => {
	await callApi.get(`${API}/views/${slug}`);

	dispatch({
		type: types.articles.ADD_VIEWS,
		payload: {
			slug,
		},
	});
};

export const addComment = newComment => async dispatch => {
	const data = await callApi.post(`${API}/comments`, newComment);

	if (data.comment) {
		dispatch({
			type: types.articles.ADD_COMMENT,
			payload: {
				comment: data.comment,
			},
		});
	}

	return data;
};

export const removeComment = commentId => async dispatch => {
	const data = await callApi.delete(`${API}/comments/${commentId}`);

	if (data.comment) {
		dispatch({
			type: types.articles.REMOVE_COMMENT,
			payload: {
				comment: data.comment,
			},
		});
	}
};
